import styled from 'styled-components/macro'

export const Gradient = styled.div`
  position: relative;
  &:after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0px;
    right: 0;
    height: 46px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.48) 55%,
      rgba(255, 255, 255, 0.88) 100%
    );
  }
`
